import HTML from './rfps.html';
import RFPManagerRfpListController from './rfps.ctrl';

export {HTML, RFPManagerRfpListController as Controller}
